module.exports = __webpack_public_path__ + "media/images/img-travel-5-d12099a0.jpg";